
import ko from 'rgs-knockout';

import ViewModel from './js/view-model';
import template from './templates/template.html';

import { SortingIcon, sortingIconTemplate } from './js/components/sorting-icon';

export * from './js/view-model';

ko.components.register('adaptive-table', {
	viewModel: {
		createViewModel: (params, elementContent) => new ViewModel(params, elementContent)
	},
	template: template(),
});

// eslint-disable-next-line rgssup/ko-component
ko.components.register('adaptive-table-sorting-icon', {
	viewModel: {
		createViewModel: (params, elementContent) => new SortingIcon(params, elementContent)
	},
	template: sortingIconTemplate(),
});